module.exports = (fox) => {

	

	fox.registerWidget('Security_Data', {
		configure() {
			this.registerOptions('', {
				widgets: {
					popupAuth: {
						widget: 'Security_Popup_Pass'
					},
					popupSetup: {
						widget: 'Security_Popup_Setup'
					},
					popupProtect: {
						widget: 'Security_Popup_Protect'
					},
					popupRequest: {
						widget: 'Security_Popup_Request'
					},
					popupForgot: {
						widget: 'Security_Popup_Forgot'
					},
					prepareApi: {
						widget: 'Api',
						method: 'profile.preservePaymentData',
						httpMethod: 'post'
					},
					activateApi: {
						widget: 'Api',
						method: 'profile.activatePaymentData',
						httpMethod: 'post'
					},
					validateHashApi: {
						widget: 'Api',
						method: 'sc.model.validateHash',
						httpMethod: 'post'
					},
					sendVerificationMail: {
						widget: 'Api',
						method: 'sc.model.sendVerificationMail',
						httpMethod: 'post'
					}
				}
			})
			this.callParent('configure', arguments);
		},

		activating() {
			let SecurityCentro = require('@centro/security-client');
			this.popupAuth = this.wom1('#popupAuth');
			this.popupSetup = this.wom1('#popupSetup');
			this.popupProtect = this.wom1('#popupProtect');
			this.popupRequest = this.wom1('#popupRequest');
			this.popupForgot = this.wom1('#popupForgot');

			this.prepareApi = this.wom1('#prepareApi');
			this.activateApi = this.wom1('#activateApi');
			this.validateHashApi = this.wom1('#validateHashApi');
			this.sendVerificationMail = this.wom1('#sendVerificationMail');
			this.sc = new SecurityCentro();
			this.userId = fox.site.member.getObjectValue('id');
			this.sc.setUserId(`client:${this.userId}`);
			//this.sc.scUrl = 'http://10.128.8.236:8111/';
			let hash = arguments[0].hash;
			if (!!hash) this.checkHash(hash);

			this.callParent('activating', arguments);
		},

		getData(scId) {
			let field = 'MoneyAccount_Settings_' + scId;
			return this.isAuth()
				.then(() => this.sc.getByAlias(field));
		},

		getDocument(scId) {
			let field = 'MoneyAccount_Settings_' + scId + '_ownershipDocument';
			return this.isAuth()
				.then(() => this.sc.getByAlias(field));
		},

		setData(data) {
			return this.isAuth()
				.then(() => {
					return this.sendData(data)
				})
				.catch((...args) => console.error(...args));
		},
		
		sendData(data) {
			return this.prepareApi.psend(data).then((res) => {
				let scId = res.params.answer.response.id;
				return this.sc._sendData(
					this.sc._composeParamsForRequest(
						{data: {['MoneyAccount_Settings_' + scId]: JSON.stringify(data)}},
						'encrypt'
					),
					this.sc.scUrl,
					null,
					this.sc
				).then(()=> scId)
			}).then((scId) => {
				let params = {cliendId: this.userId, id: scId}
				return this.activateApi.psend(params).then((result) => {return  {id: scId, result: result}})
			}).then((params) => {
				this.dispatchEvent('securityPaymentDataSaveSuccess', params.result);
				return fox.Promise.resolve(params.id);
			}).catch((err) => {
				this.dispatchEvent('paymentDataSaveFailure', err);
			})
		},

		setImageData(data, id) {
				return this.sc._sendData(
					this.sc._composeParamsForRequest(
						{data: {['MoneyAccount_Settings_' + id + '_ownershipDocument']:  data}},
						'encrypt'
					),
					this.sc.scUrl,
					null,
					this.sc
				)
		},

		isAuth() {
			if (this.sc.needAuth()) {
				return this.popupAuth.show().then((res) => {
					if (!res) {
						this.dispatchEvent('cancelPopup');
						return fox.Promise.reject('Authorization canceled');
					}
					return res;
				});
			} else {
				return fox.Promise.resolve(true);
			}
		},

		needAuth() {
			return this.sc.needAuth();
		},

		setNew(data) {
			var key = this.sc._getKey();
			return this.sc._createUser(key).then(res => {
				if (res.status === true) {
					this.sendVerificationMail.psend();
				}
				return this.isAuth();
			}).then(() => {
				return this.sendData(data);
			}).then((res) => {
				!!res ? this.popupProtect.show() : false;
				return res;
			}).catch((...args) => console.error(...args))
		},

		checkHash(hash){
			this.validateHashApi.psend({hash:hash}).then(result => {
				console.log(result);
				this.popupSetup.setOption('schash', hash);
				this.popupSetup.show();
			}).catch(err => console.log(err));
		}

	}, 'Controller');
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/security-payment-details/widget/securityData.es.js